<template>
  <!-- Tabla -->
 
    <div class="flex justify-between">
      <span class="text-xs text-indigo-500 font-mono bg-indigo-50 px-3 py-1 rounded-full shadow-sm">&lt;TablaTotalesCentroBorrador&gt;</span>
      <span class="text-xs text-indigo-500 font-mono bg-indigo-50 px-3 py-1 rounded-full shadow-sm">  api/v1/presupuestos/borrador/centro </span>
    </div>
 
  <div class="overflow-x-auto">
 
    <table class="w-full text-sm text-gray-700 mt-4 mb-4">
      <!-- THEAD -->
      <thead class="bg-gray-100 text-gray-600 uppercase text-xs tracking-wide font-mono  bg-green-800 text-white">
        <tr>
          <th class="text-left px-6 py-3">Categoría {{ tipo_categoria }}</th>
           <th class="text-right px-6 py-3">Presupuesto      {{ this.$store.state.auth.userLogin.año }}</th>
           <th class="text-right px-6 py-3">Gastos      {{ this.$store.state.auth.userLogin.año }}</th>
              <th class="text-right px-6 py-3">Ejecución      {{ this.$store.state.auth.userLogin.año }}</th>
           <th class="text-right px-6 py-3 w-[200px]  text-black   bg-yellow-100">Presupuesto      {{ this.$store.state.auth.userLogin.año_borrador }}</th>
     
        </tr>
      </thead>

      <!-- TBODY -->
      <tbody>
        <tr
          v-for="(item, index) in array_categ_base"
           
          :key="index"
          class="border-b hover:bg-gray-50 transition font-mono"
          :class="{ 'bg-gray-50': index % 2 !== 0 }"
        >
          <!-- Nombre -->
          <td class="px-6 py-3 font-medium text-gray-800">
         {{ getCategoriaActual(item.id)?.nombre || item.nombre}}
          </td>
          <td class="px-6 py-3   font-mono  text-right ">
        
             $ {{ $formatoMiles(getCategoriaActual(item.id)?.total_presupuesto || 0) }}
          </td>
           <td class="px-6 py-3   font-mono  text-right ">
        
             $ {{ $formatoMiles(getCategoriaActual(item.id)?.total_gastos || 0) }}
          </td>
           <!-- Porcentaje -->
          <td class="px-6 py-3 font-mono  ">
            <div class="flex items-center gap-3">

              <!-- Barra -->
              <div class="w-full bg-gray-200 rounded h-2 overflow-hidden">
                <div class="h-2 transition-all duration-300" :class="{
                  'bg-blue-500': getCategoriaActual(item.id)?.total_gastos / getCategoriaActual(item.id)?.total_presupuesto < 0.5,
                  'bg-yellow-500': getCategoriaActual(item.id)?.total_gastos / getCategoriaActual(item.id)?.total_presupuesto >= 0.5 && getCategoriaActual(item.id)?.total_gastos / getCategoriaActual(item.id)?.total_presupuesto < 0.8,
                  'bg-red-500': getCategoriaActual(item.id)?.total_gastos / getCategoriaActual(item.id)?.total_presupuesto >= 0.8
                }" :style="{
                    width: getCategoriaActual(item.id)?.total_presupuesto > 0
                      ? Math.min((getCategoriaActual(item.id)?.total_gastos / getCategoriaActual(item.id)?.total_presupuesto) * 100, 100) + '%'
                      : '0%'
                  }"></div>
              </div>

              <!-- Texto porcentaje -->
              <span class="w-14 text-right">
                {{
                  getCategoriaActual(item.id)?.total_presupuesto > 0
                    ? ((getCategoriaActual(item.id)?.total_gastos / getCategoriaActual(item.id)?.total_presupuesto) * 100).toFixed(1)
                    : 0
                }}%
              </span>

            </div>
          </td>
          <!-- Presupuesto -->
          <td class="px-6 py-3 text-right font-mono text-gray-800  bg-green-100">
            $ {{ $formatoMiles(getCategoriaBorrador(item.id)?.total_presupuesto || 0)  }}
          </td>
         
         
        </tr>
      </tbody>

      <!-- TFOOT -->
      <tfoot class="bg-gray-100">
        <tr>
          <td class="px-6 py-3 font-semibold text-gray-800">  </td>
            <td class="px-6 py-3 text-right font-semibold font-mono"> $ {{ $formatoMiles(tot_tabla2.presupuestos) }}  </td>
               <td class="px-6 py-3 text-right font-semibold font-mono">$   {{ $formatoMiles(tot_tabla2.gastos) }}  </td>
                 <td class="px-6 py-3 text-right font-semibold font-mono"> 
                   {{ 
                     tot_tabla2.presupuestos > 0 
                     ?
                    ((tot_tabla2.gastos / tot_tabla2.presupuestos) * 100).toFixed(1)  
                    :0
                   }}
                   % </td>
          <td class="px-6 py-3 text-right font-semibold font-mono">$ {{ $formatoMiles(total_presupuesto_centro)}}</td>
          
           
        </tr>
      </tfoot>
    </table>
  </div>
</template>

<script>
import api from "@/api/axios";
import { agrupa_categorias_suma_presupuestos2 } from "@/services/reporteria.services.js"
 
export default {
  name: "TablaTotalesCentros",
  props: {
    centro_id: {
      type: Number,
      required: true
    },
    
    prop_incluyeCero:{
      type:Boolean
    },
    date_time: {
      type: String,
      
    },
    capitalInvestment:{
        type: Boolean,
        default: false
    }
  },
  mounted(){
    this.categoriasAgrupadas()
  },
  computed: {
    tot_tabla1() {
    return this.presupuesto_categorias_borrador.reduce(
      (acc, item) => {
        acc.presupuestos += Number(item.total_presupuesto || 0);
        acc.gastos += Number(item.total_gastos || 0);
      
        return acc;
      },
      { presupuestos: 0, gastos: 0  }
    );
  },
  tot_tabla2() {
      return this.presupuesto_categorias_año_actual.reduce(
        (acc, item) => {
          acc.presupuestos += Number(item.total_presupuesto || 0);
          acc.gastos += Number(item.total_gastos || 0);
          console.log('--->', acc.presupuestos)
          return acc;
        },
        { presupuestos: 0, gastos: 0 }
      );
    },
    
    filteredArray() {
      return this.array_categ_base.filter((_, index) => {
          return this.getCategoriaActual(this.array_categ_base[index].id)?.total_presupuesto    || 
                this.getCategoriaBorrador(this.array_categ_base[index].id)?.total_presupuesto  
      })
    }
  },
   watch: {
      date_time: function(){
         this.categoriasAgrupadas()
    },
    centro_id: function (value) {
     console.log('montando', value, this.centro_id)
       this.categoriasAgrupadas()
    },
    prop_incluyeCero: function(){
       this.incluyeCero = this.prop_incluyeCero;
    },
    
  },
  data() {
    return {
      valor: "",
      listado: {},
      ID_CATEGORIA_INVERSIONES : process.env.VUE_APP_ID_CATEGORIA_INVERSIONES,
      categorias: {},
      tipos: {},
      tipo_categoria: this.capitalInvestment ? 'CAPITAL INVESTMENT 🪙': 'OPERACIONAL 💵',
      cuentamodif: 0,
      
      total_presupuesto_centro: 0,
      presupuesto_categorias_borrador: [],
      presupuesto_categorias_año_actual:[],
      total_gastos_centro:0,
      loading:false,
      incluyeCero:false,
      array_categ_base:[],
      refresh:false
    } 
  },
  methods: {
    getCategoriaActual(categoriaId) {
      return this.presupuesto_categorias_año_actual.find(
        actual => actual.id === categoriaId
      );
    },
     getCategoriaBorrador(categoriaId) {
      return this.presupuesto_categorias_borrador.find(
        borrador => borrador.id === categoriaId
      );
    },
     deprecated_categoriasAgrupadas() {
        console.log('hola')
    },
    async categoriasAgrupadas() {
 
    //INICIO --------------------------------------------
    // extraer listado de categorias para la tabla
    // en el TEMPLATE se iterará este listado de categorias 
    // si hay presupuesto en el año actual o en el borrador
    

    let ctas;
    const allctas = this.$store.state.cuentas.cuentas
    if (this.capitalInvestment) {
        ctas = allctas.filter(
          cta => cta.tipo_cuenta?.categoria_cuenta?.id === parseInt(this.ID_CATEGORIA_INVERSIONES)
        );
    }else{
         ctas = allctas.filter(
          cta => cta.tipo_cuenta?.categoria_cuenta?.id !== parseInt(this.ID_CATEGORIA_INVERSIONES)
        );
    }

      
    const categoriasMap = {};
    ctas.forEach(cuenta => {
      const categoria = cuenta.tipo_cuenta.categoria_cuenta;
        if (this.capitalInvestment) {


          if (!categoriasMap[categoria.id] && categoria.id === parseInt(this.ID_CATEGORIA_INVERSIONES)) {
            categoriasMap[categoria.id] = {
              id: categoria.id,
              nombre: categoria.nombre,
              orden: categoria.orden
            };
          }

        } else {

        if (!categoriasMap[categoria.id] && categoria.id !== parseInt(this.ID_CATEGORIA_INVERSIONES)) {
            categoriasMap[categoria.id] = { 
              id: categoria.id,
              nombre: categoria.nombre,
              orden: categoria.orden
            };
          }
        }

    });
  
    
  this.array_categ_base = Object.values(categoriasMap)
    .sort((a, b) => a.orden - b.orden);

      console.log("array_categ_base",this.array_categ_base)
// FIN ------------------------------------------------------


      // recupera cuentas con presupuestos ingresados
      this.loading=true;
      let presupuestos;
      try {
        const data = {
          centro_id: this.centro_id,
          
        };
        if (this.incluyeCero) {
          data["incluyeCero"] = this.incluyeCero;
        }
        // solo trae presupuestos > 0
        const response = await api.post("api/v1/presupuestos/borrador/centro/", data, {
          headers: {
            "Content-Type": "application/json",
          },
        });

        if (response.status === 200) 
        {
          this.año= response.data.año;
          presupuestos = response.data.presupuestos;
          const obj = agrupa_categorias_suma_presupuestos2( presupuestos, ctas)
          this.presupuesto_categorias_borrador  = obj.array_presupuesto_categorias
          /*  
               contiene el mismo centro_id
               en todos sus registros

               los cuenta_id no se repiten
               
               "presupuestos": 
               [
                    {
                        "id": 5816,
                        "centro_id": 6,
                        "cuenta_id": 8,
                        "empresa_id": 1,
                        "aa": 2025,
                        "moneda_id": 1,
                        "total_presupuesto": "900000.00",
                        "total_gastos": "0.00"
                    },
                    
                  v/s   this.$store.state.cuentas.cuentas
                  [{
                    "id":112,
                    "codigo":"4.5.1030.80.44",
                    "nombre":"Alarma",
                    "tipo_cuenta":{
                    "id":13,
                    "nombre":"GTOS BASICOS CASAS E INSTALACIONES",
                    "categoria_cuenta":{
                        "id":8,
                        "nombre":"GASTOS GENERALES"
                    }
                    }
                  */

         
 
          this.loading = false;
        
        }
/*
[
    {
        "id": 5,
        "nombre": "COMUNICACIONES y GESTION INSTITUCIONAL",
        "tipos": [
            {
                "id": 8,
                "nombre": "COMUNICACIONES y GESTION INSTITUCIONAL",
                "cuentas": [
                    {
                        "id": 36,
                        "cod": "4510305002",
                        "nomcta": "Folleteria",
                        "total_presupuesto": 300000,
                        "total_gastos": 0,
                        "saldo": 300000
                    },
                    {
                        "id": 40,
                        "cod": "4510305006",
                        "nomcta": "Eventos",
                        "total_presupuesto": 7300000,
                        "total_gastos": 8898,
                        "saldo": 7291102
                    },
                    {
                        "id": 41,
                        "cod": "4510305007",
                        "nomcta": "Fotografía",
                        "total_presupuesto": 500000,
                        "total_gastos": 0,
                        "saldo": 500000
                    }
                ]
            }
        ],
        "orden": 4
    },
 
]

*/
          
            this.total_presupuesto_centro = this.presupuesto_categorias_borrador.reduce(
                (acc, cat) => acc + Number(cat.total_presupuesto),
                0
            );

            this.total_gastos_centro = this.presupuesto_categorias_borrador.reduce(
                (acc, cat) => acc + Number(cat.total_gastos),
                0
            );



        const data2 = {
          centro_id: this.centro_id,
          borrador: false
        };
        const response_año_abierto = await api.post("api/v1/presupuestos/centro/", data2, {
          headers: {
            "Content-Type": "application/json",

          },
        });
        if (response_año_abierto.status == 200) 
        {
          const obj = agrupa_categorias_suma_presupuestos2(response_año_abierto.data.presupuestos, ctas)
          this.presupuesto_categorias_año_actual = obj.array_presupuesto_categorias
          console.log(this.presupuesto_categorias_año_actual,"<---")
        }  
            
      } catch (e) {
        console.error("Credenciales inválidas ❌", e);
      }
    },
  },
};
</script>
